import React from "react";
import { useAppSelector } from "../../../store/hooks";
import { selectors as shipBuilderSelectors } from "../../../store/selectors/shipBuilderSelectors";
import { selectIsBreakaway } from "../../../store/selectors/breakawayHullSelectors";
import { formatCurrency, formatNumber } from "../../../utils/formatting";
import { BreakawaySection } from "../../../types/breakawayHull";
import { BreakawaySectionSummary } from "./BreakawaySectionSummary";

export const BreakawayHullsSummary: React.FC = () => {
  const hull = useAppSelector(shipBuilderSelectors.selectHull);
  
  // Check if breakaway hulls are configured
  const isBreakaway = useAppSelector(selectIsBreakaway);
  const breakawayHull = useAppSelector((state) => state.breakawayHull);
  const hasBreakawayHulls = isBreakaway || breakawayHull?.isBreakaway;

  if (!hasBreakawayHulls) {
    return null;
  }

  const sections = breakawayHull?.sections || [];
  const totalShipSize = hull?.size || 0;

  return (
    <div className="space-y-8">
      {/* Overall Summary Header */}
      <div className="bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-700 rounded-lg p-6">
        <div className="flex justify-between items-start">
          <div>
            <h2 className="text-3xl font-bold text-blue-900 dark:text-blue-100 mb-2">
              BREAKAWAY HULLS SUMMARY
            </h2>
            <h3 className="text-xl font-semibold text-blue-800 dark:text-blue-200 mb-2">
              Breakaway Hull Configuration
            </h3>
            <p className="text-blue-700 dark:text-blue-300">
              This ship is configured as {sections.length} breakaway section{sections.length !== 1 ? 's' : ''} with a total size of {formatNumber(totalShipSize)} tons.
            </p>
          </div>
          <div className="text-right">
            <div className="text-sm text-blue-600 dark:text-blue-400 mb-1">Total Ship Statistics</div>
            <div className="text-lg font-semibold text-blue-900 dark:text-blue-100">
              Cost: {formatCurrency(hull?.cost || 0)}
            </div>
            <div className="text-sm text-blue-700 dark:text-blue-300">
              Weight: {formatNumber(hull?.weight || 0)} tons
            </div>
            <div className="text-sm text-blue-700 dark:text-blue-300">
              Size: {formatNumber(hull?.size || 0)} tons
            </div>
          </div>
        </div>
      </div>

      {/* Individual Section Summaries */}
      {sections.map((section: BreakawaySection) => (
        <BreakawaySectionSummary
          key={section.id}
          section={section}
          totalShipSize={totalShipSize}
        />
      ))}
    </div>
  );
};